// AddRemoveButtons.tsx
import React from "react";
import { Plus, Minus } from "lucide-react";
import { Button } from "@/components/button";

export const AddRemoveButtons: React.FC<{
  isFirst: boolean;
  onAdd: () => void;
  onRemove: () => void;
  disableAdd?: boolean;
}> = ({ isFirst, onAdd, onRemove, disableAdd }) => (
  <div className="flex items-center justify-end gap-2">
    {isFirst ?
      <Button
        type="button"
        size="icon-sm"
        onClick={onAdd}
        disabled={disableAdd}
        className={`circle-btn border transition-colors ${
          disableAdd ?
            "cursor-not-allowed border-[#5a5a5a] bg-[#5a5a5a] text-[#e1e1e1]"
          : "border-[#379a2a] bg-[#379a2a] text-white"
        }`}
        aria-label="Add row"
        title={disableAdd ? "Cannot add more rows" : "Add condition"}
      >
        <Plus className="h-3 w-3 stroke-[2]" />
      </Button>
    : <Button
        type="button"
        size="icon-sm"
        onClick={onRemove}
        className="circle-btn border border-[#379a2a] bg-white text-[#379a2a]"
        aria-label="Remove row"
        title="Remove condition"
      >
        <Minus className="h-3 w-3 stroke-[2]" />
      </Button>
    }
  </div>
);
